/**
 * Nút "Tính tiền" luôn thấy ở màn Lịch (KH-GĐ2 4.2.4): một chạm mở tờ chọn khách đang làm / vừa xong mà
 * chưa thu → tờ thu tiền có sẵn (ToHoanTat, tự điền dịch vụ + giá của lịch). Khách không có lịch → "Khách vào"
 * (ghi vào lịch trước rồi mới thu — hoá đơn dịch vụ luôn gắn một lịch, ADR-043).
 */
import { ChevronRight, ReceiptText, UserRoundPlus, X } from 'lucide-react'
import { type DayAppointment, gioPhut, tenDichVu, tenKhach } from './api.ts'
import { lichChoThu } from './man-dau.ts'
import { G } from './text/goi-vi.ts'
import { T } from './text/vi.ts'
import { Rong, To } from './ui.tsx'

/** Viền, không phải nút chính: nút chính của màn vẫn là "Đặt lịch cho khách" (một hành động chính / màn). */
export function NutTinhTien({ onMo }: { onMo: () => void }) {
  return (
    <button type="button" className="nut nut-vien" onClick={onMo}>
      <ReceiptText size={20} />
      {T.checkoutBtn}
    </button>
  )
}

export function ToTinhTien({
  ds,
  onChon,
  onKhachVao,
  onDong,
}: {
  ds: DayAppointment[]
  onChon: (a: DayAppointment) => void
  /** `null`: không phải hôm nay / vai không đặt lịch → không có lối "Khách không có lịch". */
  onKhachVao: (() => void) | null
  onDong: () => void
}) {
  const cho = lichChoThu(ds)
  return (
    <To nhan={T.checkoutTitle} onDong={onDong}>
      <header className="to-dau">
        <h2>{T.checkoutTitle}</h2>
        <button
          type="button"
          className="nut nut-nhat nut-icon"
          aria-label={T.close}
          onClick={onDong}
        >
          <X size={22} />
        </button>
      </header>
      <div className="to-than">
        {cho.length === 0 ? (
          <Rong
            icon={<ReceiptText size={28} />}
            tieuDe={T.checkoutNone}
            moTa={T.checkoutNoneHint}
          />
        ) : (
          <div className="ds-chon ds-tinh-tien">
            {cho.map((a) => (
              <button
                key={a.appointmentId}
                type="button"
                className="muc-chon"
                onClick={() => onChon(a)}
              >
                <span className="chu">
                  <b>{tenKhach(a.customerName)}</b>
                  <span>
                    {gioPhut(a.startMin)} · {tenDichVu(a.serviceName)} ·{' '}
                    {a.status === 'done' ? G.chuaThu : T.checkoutDoing}
                  </span>
                </span>
                <ChevronRight size={20} />
              </button>
            ))}
          </div>
        )}
        {onKhachVao !== null && (
          <div className="ds-tinh-tien">
            <button type="button" className="muc-chon" onClick={onKhachVao}>
              <UserRoundPlus size={20} />
              <span className="chu">
                <b>{T.checkoutWalkIn}</b>
                <span>{T.checkoutWalkInHint}</span>
              </span>
              <ChevronRight size={20} />
            </button>
          </div>
        )}
      </div>
    </To>
  )
}
